import { useCallback, useEffect, useState } from "react";
import ElementCard from "../../components/elementCard/ElementCard.component";
import Box from "@mui/material/Box";
import PreviousNext from "../../components/previousNext/PreviousNext.component";
import { searchDefinitionsFull, searchTerms } from "../../commons/Api";
import LaSpinner from "../../components/spinner/LaSpinner.component";
import PageTitle from "../../components/pageTitle/PageTitle.component";
import { useNavigate, useParams } from "react-router";
import Response_Term from "./../../types/responses/Response.Term.type";
import DefinitionCard from "../../definitions/definitionCard/DefinitionCard";
import classes from "./SearchResultPage.module.css";
import { handleErrorRouting } from "../../commons/LaUtils";
import Response_Definition from "../../types/responses/Response.Definition.type";

/**
 * Todo-adi: refactor code
 */
const SearchResultsPage = () => {
  const { query } = useParams();
  const normalizedQuery = (query ?? "").trim();
  const [terms, setTerms] = useState<Response_Term[]>();
  const [definitions, setDefinitions] = useState<Response_Definition[]>();
  const [loadingTerms, setLoadingTerms] = useState(true);
  const [loadingDefinitions, setLoadingDefinitions] = useState(true);
  const [nextPageTerms, setNextPageTerms] = useState<string | undefined>(
    undefined,
  );
  const [nextPageDefinitions, setNextPageDefinitions] = useState<
    string | undefined
  >(undefined);
  const navigate = useNavigate();

  const title = "Search result for query '" + normalizedQuery + "'";
  const size = 5;

  const getTerms = useCallback(
    (_orderedBy: string | undefined, page: string | undefined) => {
      setLoadingTerms(true);
      if (!normalizedQuery) {
        setNextPageTerms(undefined);
        setLoadingTerms(false);
        return;
      }
      let adoptedPage: number = page === undefined ? 0 : +page;
      searchTerms(normalizedQuery, adoptedPage, size)
        .then((response) => {
          setTerms(response.data.terms);
          setNextPageTerms(
            response.data.nextPage === null
              ? undefined
              : response.data.nextPage,
          );
        })
        .catch((error) => {
          handleErrorRouting(error, (url: string) => navigate(url));
        })
        .finally(() => {
          setLoadingTerms(false);
        });
    },
    [navigate, normalizedQuery, size],
  );

  const getDefinitions = useCallback(
    (_orderedBy: string | undefined, page: string | undefined) => {
      setLoadingDefinitions(true);
      if (!normalizedQuery) {
        setNextPageDefinitions(undefined);
        setLoadingDefinitions(false);
        return;
      }
      let adoptedPage: number = page === undefined ? 0 : +page;
      searchDefinitionsFull(normalizedQuery, adoptedPage, size)
        .then((response) => {
          setDefinitions(response.data.definitions);
          setNextPageDefinitions(
            response.data.nextPage === null
              ? undefined
              : response.data.nextPage,
          );
        })
        .catch((error) => {
          handleErrorRouting(error, (url: string) => navigate(url));
        })
        .finally(() => {
          setLoadingDefinitions(false);
        });
    },
    [navigate, normalizedQuery, size],
  );

  useEffect(() => {
    getTerms(undefined, undefined);
    getDefinitions(undefined, undefined);
    window.scrollTo({ top: 0, left: 0 });
  }, [getDefinitions, getTerms]);

  return (
    <div className="max-width row-sm">
      <PageTitle title={title} />
      {loadingTerms && terms === undefined ? (
        <Box>
          <LaSpinner />
        </Box>
      ) : (
        <>
          <div className={classes.smallTitle}>Terms</div>
          {terms !== undefined &&
            terms.map((term: Response_Term) => {
              return (
                <ElementCard
                  key={term.id}
                  termId={term.id}
                  termName={term.name}
                  termCreatedOn={term.createdOn}
                  termLastUpdatedOn={term.lastUpdatedOn}
                  termTotalDefinitionCount={term.totalDefinitionCount}
                  termState={term.state + ""}
                />
              );
            })}

          <PreviousNext
            nextPage={nextPageTerms}
            getData={getTerms}
            historyKey="search-results-terms"
          />

          {/*////////////*/}
          {/* <div className={classes.pageHr}>
            <hr />
          </div> */}

          {/*////////////*/}

          {loadingDefinitions && definitions === undefined ? (
            <Box>
              <LaSpinner />
            </Box>
          ) : (
            <>
              <div className={classes.topMargin2}></div>
              <div className={`${classes.smallTitle}`}>Definitions</div>
              {definitions !== undefined &&
                definitions.map(
                  (definitionAsSearchResult: Response_Definition, index) => {
                    return (
                      <DefinitionCard
                        definition={definitionAsSearchResult}
                        key={index}
                        isProfile
                      />
                    );
                  },
                )}
              <PreviousNext
                nextPage={nextPageDefinitions}
                getData={getDefinitions}
                historyKey="search-results-definitions"
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SearchResultsPage;
